import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const EventListApi = createApi({
  reducerPath: "EventListApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_HOST }),
  endpoints: (builder) => ({
    getEventList: builder.query({
      query: (data) => ({
        url: "get/events/listing",
        method: "POST",
      }),
    }),
    //  verifyOTP: builder.mutation({
    //    query: (data) => ({
    //      url: "candidate/otp_verification",
    //      method: "POST",
    //      body: data,
    //    }),
    //  }),
  }),
});

export const { useGetEventListQuery } = EventListApi;
